import { supabase } from './supabase';

// Who a chat can be reassigned to: active people with Sentinel (Portal) access, the same
// list and test as the Portal's reassign picker (LiveDesk, loadOperators). The server
// (messaging-send, reassign) checks again.

export interface Person { id: string; name: string; posStaff: boolean }

export async function loadPeople(opts: { withMobile?: boolean } = {}): Promise<Person[]> {
  const { data } = await supabase.from('users')
    .select('id, first_name, last_name, permissions, is_pos_staff, phone').eq('status', 'active').order('first_name');
  const rows = ((data ?? []) as { id: string; first_name: string | null; last_name: string | null; permissions: unknown; is_pos_staff: boolean | null; phone: string | null }[])
    .filter((u) => !!u.permissions && typeof u.permissions === 'object' && !Array.isArray(u.permissions)
      && Object.keys(u.permissions).some((k) => !['ambassador_portal', 'pos_portal', '_scope'].includes(k)));
  // Team members are people with a mobile on their login, one login per mobile (Gary, 15 Oct):
  // spare logins of the same person have none and stay out until updated.
  const digits = (p: string | null) => (p ?? '').replace(/\D/g, '');
  const kept = opts.withMobile
    ? rows.filter((u, i) => digits(u.phone).length >= 9 && rows.findIndex((o) => digits(o.phone) === digits(u.phone)) === i)
    : rows;
  return kept.map((u) => ({ id: u.id, name: [u.first_name, u.last_name].filter(Boolean).join(' ') || 'Unnamed', posStaff: u.is_pos_staff === true }));
}
